import React, { useEffect, useState } from "react";
import FileDownload from "js-file-download";
import axios from "axios";

// const env = import.meta.env;
// export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

//Fetch Incident Response Plan List
export const fetchIncidentResponsePlanList = async (
  companyProfileID: number
) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/IncidentResponsePlan/CompanyId/${companyProfileID}/Details`
    );

    // console.log("fetchIncidentResponsePlanList res", res);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Fetch Incident Response Plan by Id
export const fetchIncidentResponsePlanById = async (
  incidentResponseInfoPlanID: number
) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/IncidentResponsePlan/Id/${incidentResponseInfoPlanID}/Details`
    );

    // console.log("fetchIncidentResponsePlanList res", res);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Create Incident Response Plan
export const createIncidentResponsePlan = async (payload: any) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/api/IncidentResponsePlan/Create`,
      payload
    );

    // console.log("createIncidentResponsePlan res", res);
    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Update Incident Response Plan
export const updateIncidentResponsePlan = async (payload: any) => {
  try {
    const res = await axios.put(
      `${API_BASE_URL}/api/IncidentResponsePlan/Update`,
      payload
    );

    // console.log("updateIncidentResponsePlan res", res);
    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Delete Incident Response Plan
export const deleteIncidentResponsePlan = async (payload: any) => {
  try {
    const res = await axios.put(
      `${API_BASE_URL}/api/IncidentResponsePlan/Delete`,
      payload
    );

    // console.log("deleteIncidentResponsePlan res", res);
    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Download Incident Response Plan
export const downloadIncidentResponsePlan = async (
  companyProfileID: number,
  payload: any
) => {
  try {
    axios({
      url: `${API_BASE_URL}/api/IncidentResponsePlan/GenerateDocument?CompanyProfileID=${companyProfileID}&IncidentResponseInfoPlanID=${payload.incidentResponseInfoPlanID}`,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      // console.log("downloadIncidentResponsePlan res", payload, response);
      FileDownload(
        response.data,
        `Incident Response Plan version ${payload.version}.docx`
      );
    });
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Fetch Incident Response Plan Template
export const fetchIncidentResponsePlanTemplate = async (
  userId: number,
  companyProfileID: number
) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/IncidentResponsePlan/TemplateDetails`
    );

    // console.log("fetchIncidentResponsePlanTemplate res", res);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

export const createRevisionHistory = async (payload: any) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/api/IncidentResponsePlan/CreateRevisionHistory`,
      payload
    );

    // console.log("createRevisionHistory res", res);
    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};
